module.exports = __webpack_public_path__ + "vertical-db.ce5e9ea7036b3a945314f86aea6a181b.png";